import { Link } from "wouter";
import { Coffee } from "lucide-react";

/**
 * TipBox — a small, persistent floating button that links to the tip page.
 * Rendered globally in App.tsx so it appears on every page.
 */
export default function TipBox() {
  return (
    <Link href="/tip">
      <button
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-2.5 bg-card border border-border/50 rounded-full shadow-lg hover:shadow-xl hover:border-primary/50 transition-all duration-200 group"
        title="Tip CloserAI"
      >
        <Coffee className="h-4 w-4 text-primary group-hover:scale-110 transition-transform" />
        <span className="text-xs font-medium text-muted-foreground group-hover:text-foreground transition-colors">
          Tip
        </span>
      </button>
    </Link>
  );
}
